module.exports = __webpack_public_path__ + "img/order_photo_image@3x.cb0d1b74.png";